import { format, subDays } from "date-fns";
import { FILTER_IS_FAVORITE } from "@/constants/filterRules";
import { DATE_FORMAT_ISO } from "@/constants/theme";

const shortcuts = [
  {
    icon: "restore",
    title: "latest",
    filterRules: [],
    viewMode: "list",
    view: "long",
    startDate: format(subDays(new Date(), 40), DATE_FORMAT_ISO),
    endDate: format(new Date(), DATE_FORMAT_ISO),
    default: true,
    emitEvent: "refresh-feed"
  },
  {
    icon: "star",
    title: "myFavorites",
    filterRules: [
      {
        type: FILTER_IS_FAVORITE.name,
        values: [true]
      }
    ],
    viewMode: "list",
    view: "long",
    startDate: format(subDays(new Date(), 40), DATE_FORMAT_ISO),
    endDate: format(new Date(), DATE_FORMAT_ISO)
  },
  {
    icon: "notes",
    title: "latestText",
    filterRules: [
      {
        type: "FILTER_ITEMCLASS",
        values: ["http://cv.iptc.org/newscodes/ninature/text"]
      }
    ],
    viewMode: "list",
    view: "long",
    startDate: format(subDays(new Date(), 1), DATE_FORMAT_ISO),
    endDate: format(new Date(), DATE_FORMAT_ISO),
    default: true
  },
  {
    icon: "photo",
    title: "latestPictures",
    filterRules: [
      {
        type: "FILTER_ITEMCLASS",
        values: ["http://cv.iptc.org/newscodes/ninature/picture"]
      }
    ],
    viewMode: "list",
    view: "long",
    startDate: format(subDays(new Date(), 1), DATE_FORMAT_ISO),
    endDate: format(new Date(), DATE_FORMAT_ISO),
    default: true
  },
  {
    icon: "mdi-chart-bar",
    title: "latestGraphics",
    filterRules: [
      {
        type: "FILTER_ITEMCLASS",
        values: ["http://cv.iptc.org/newscodes/ninature/graphic"]
      }
    ],
    viewMode: "list",
    view: "long",
    startDate: format(subDays(new Date(), 1), DATE_FORMAT_ISO),
    endDate: format(new Date(), DATE_FORMAT_ISO),
    default: true
  }
];

export default shortcuts;
